export enum AccountTarget {
  COMPANY = 'COMPANY',
  CLIENT = 'CLIENT',
}
